export const selectAssessmentLoading = (state) => state.assessment.loading
export const selectAssessmentError = (state) => state.assessment.error
export const selectAssessments = (state) => state.assessment.assessments
export const selectAssessmentPagination = (state) => state.assessment.pagination
export const selectAssessmentTypes = (state) => state.assessment.assessmentTypes
export const selectKpiData = (state) => state.assessment.kpiData
export const selectStudents = (state) => state.assessment.students
export const selectStudentsPagination = (state) => state.assessment.studentsPagination
export const selectStudentsLoading = (state) => state.assessment.studentsLoading
export const selectReport = (state) => state.assessment.report
export const selectReportLoading = (state) => state.assessment.reportLoading
